
import jquery from "jquery";
window.$ = window.jQuery = jquery;
var variantsJson = {}

function getAllProducts(element) {
    element.forEach(item =>{
        if(!!item.getAttribute('data-product-handle')) {
            var product_handle = item.getAttribute('data-product-handle');
            jQuery.getJSON( `https://junoandme.de/products/${product_handle}.js`, function(product) {
                
                if (!!product && !!product.variants) {
                     product.variants.forEach(variant=>{
                        variantsJson[`${variant.title}`]= {
                            id: variant.id,
                            originalProdIHandle: product.handle,
                            price: variant.price,
                            available: variant.available,
                            title: variant.title
                        }
                    })
                }
            });
        }
    })
}
function changeValuesVariant() {
    document.querySelectorAll('.product-form__set-selector--size').forEach(function(selector){
        document.querySelectorAll('.color-swatch__radio--panty').forEach(function(input){
            let formIDInit = ''
            let formInputInit = ''
            if(input.checked){
                selector.addEventListener('change', function(elem){
                    if (!!elem.target.getAttribute('data-form-id')) {
                        formIDInit = document.querySelector(`#${elem.target.getAttribute('data-form-id')}`)
                    }
                    if (!!formIDInit) {
                        formInputInit = formIDInit.querySelector(`#product__input--variants-${input.getAttribute('data-original-product')}`)
                        if(!!formInputInit) {
                            if(!!variantsJson[`${elem.target.value} / ${input.value}`]){
                                changeValuesFormInput(formInputInit,variantsJson[`${elem.target.value} / ${input.value}`])
                            }
                        }
                    }
                })
            }

            input.addEventListener('change', function(el){
                if (!!el.target.getAttribute('data-form-id')) {
                    formIDInit = document.querySelector(`#${el.target.getAttribute('data-form-id')}`)
                }
                if (!!formIDInit) {
                    formInputInit = formIDInit.querySelector(`#product__input--variants-${el.target.getAttribute('data-original-product')}`)
                    if(!!formInputInit) {
                       if (!!variantsJson[`${selector.options[selector.selectedIndex].value} / ${el.target.value}`]) {
                            changeValuesFormInput(formInputInit,variantsJson[`${selector.options[selector.selectedIndex].value} / ${el.target.value}`])
                        }
                    }
                }
            })
        })
    })

    document.querySelectorAll('.color-swatch__radio--panty').forEach(function(input){
        input.addEventListener('change', function(el){
            let formID = ''
            if (!!el.target.getAttribute('data-form-id')) {
                formID = document.querySelector(`#${el.target.getAttribute('data-form-id')}`)
            }
            if (formID) {
                var inputName = el.target.value
                if(!!document.querySelectorAll('.product-form__set-selector--size')){
                    document.querySelectorAll('.product-form__set-selector--size').forEach(function(selector){
                        selector.addEventListener('change', function(elem){
                            var formInput = formID.querySelector(`#product__input--variants-${el.target.getAttribute('data-original-product')}`)
                            if(!!formInput) {
                                if(!!variantsJson[`${elem.target.value} / ${inputName}`]){
                                    changeValuesFormInput(formInput, variantsJson[`${elem.target.value} / ${inputName}`])
                                }
                            }
                        })
                    })
                }
            }
            if (!!el) {
                changeImage(el)
            }
        })
    })

}
function changeValuesFormInput(form,obj) {
    if (!!form && !!obj) {
        if(obj.available === true) {
            form.value = obj.id
        }
        if (obj.available === false ) {
            var comingSoonForm = form.parentNode.querySelector('.product-item__action-button').getAttribute('data-coming-soon');
            form.parentNode.querySelector('.product-item__action-button').classList.add('button--disabled')
            form.parentNode.querySelector('.product-item__action-button').classList.remove('button--primary')
            form.parentNode.querySelector('.product-item__action-button').setAttribute('disabled', 'disabled');
            if (comingSoonForm == 'true') {
                form.parentNode.querySelector('.product-item__action-button').innerHTML= window.languages.productFormComingSoon;
            } else {
                form.parentNode.querySelector('.product-item__action-button').innerHTML= window.languages.productFormSoldOut;
              }
        }else {
            form.parentNode.querySelector('.product-item__action-button').classList.add('button--primary')
            form.parentNode.querySelector('.product-item__action-button').classList.remove('button--disabled')
            form.parentNode.querySelector('.product-item__action-button').removeAttribute('disabled', 'disabled');
            form.parentNode.querySelector('.product-item__action-button').innerHTML= window.languages.productFormAddToCart;
        }
    }
}
function changeImage(el) {
    if (!!el) {
        let productItemParent = el.target.closest('.product-item'),
        variantUrlAttr = el.target.getAttribute('data-variant-url');
        productItemParent.querySelector('.product-item__image-wrapper').setAttribute('href', variantUrlAttr);
        productItemParent.querySelector('.product-item__title').setAttribute('href', variantUrlAttr);
        if (!!productItemParent) {
            let originalImage = productItemParent.querySelector('.product-item__primary-image');
            if (el.target.hasAttribute('data-image-url') && el.target.getAttribute('data-media-id') !== originalImage.getAttribute('data-media-id')) {
                let newImageEl = document.createElement('img');
                newImageEl.className = 'product-item__primary-image lazyload image--fade-in';
                if(!!el.target.getAttribute('data-media-id') && !!el.target.getAttribute('data-image-url')){
                    newImageEl.setAttribute('data-media-id', el.target.getAttribute('data-media-id'));
                    newImageEl.setAttribute('data-src', el.target.getAttribute('data-image-url'));
                    newImageEl.setAttribute('data-widths', el.target.getAttribute('data-image-widths'));
                    newImageEl.setAttribute('data-sizes', 'auto'); // Replace the original node
                }
         
                if (!!originalImage && !!newImageEl) {
                    originalImage.parentNode.style.paddingBottom = "".concat(100.0 / newImageEl.getAttribute('data-image-aspect-ratio'), "%");
                    originalImage.parentNode.replaceChild(newImageEl, originalImage);
                }
            }
        }
    }
}
document.addEventListener("DOMContentLoaded", function () {
    let productItemEl = document.querySelectorAll('.product-item--wrapper')
    if (!!productItemEl) {
        getAllProducts(productItemEl)
        changeValuesVariant();
    }

});

//needed for recently viewed section, as the DOM takes longer to load there
document.addEventListener("products:loaded", function () {
    setTimeout(function () {
        let productItemWrapper = document.querySelectorAll('.product-item--wrapper')
        if (!!productItemWrapper) {
            getAllProducts(productItemWrapper)
            changeValuesVariant();  
        }
    }, 2000);
})